import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { getLangTime, postTimeZone } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { Form, Spinner } from "reactstrap";
import * as Yup from "yup";
import { isEmpty } from "lodash";
import { me } from "constants/Client";

const TimeZone = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const user = me();
  const [timezone, setTimezone] = useState();
  const [options, setOptions] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const animatedComponents = makeAnimated();

  const { time_zones, response } = useSelector(state => ({
    time_zones: state.StaffByEmail.langTime,
    response: state.ServiceList.timezoneRes,
  }));

  useEffect(() => {
    setLoading(true);
    dispatch(getLangTime());
  }, []);

  useMemo(() => {
    setOptions([]);
    setLoading(false);
    Array.isArray(time_zones.time_zone)
      ? time_zones.time_zone.map(val => {
          setOptions(pre => [...pre, { label: val.time_zone, value: val.time_zone }]);
        })
      : null;
  }, [time_zones]);

  useEffect(() => {
    try {
      if (!isEmpty(response) && isClicked) {
        onSuccess();
        setIsClicked(() => !isClicked);
      }
    } catch (er) {
      console.log(er);
    }
  }, [response, dispatch]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { mytimezone: [] },
    validationSchema: Yup.object().shape({
      mytimezone: Yup.object()
        .shape({
          value: Yup.string(),
          label: Yup.string(),
        })
        .nullable()
        .required("This field is required."),
    }),
    onSubmit: values => {
      setIsClicked(true);
      setTimeout(() => setIsClicked(false), [1000 * 8]);
      dispatch(
        postTimeZone({
          input_id: user.role === "manager" ? user.manager_uid : user.uid,
          user_type: user.role,
          time_zone: values.mytimezone.value,
        })
      );
    },
  });

  return (
    <React.Fragment>
      <Form
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit(e);
          return false;
        }}>
        <Select
          value={timezone}
          isMulti={false}
          onChange={e => {
            setTimezone(e);
            validation.setFieldValue("mytimezone", e);
          }}
          options={options || []}
          classNamePrefix='select2-selection'
          closeMenuOnSelect={true}
          components={animatedComponents}
          isLoading={loading}
        />
        <span className={`invalid-feedback d-${validation.touched.mytimezone && validation.errors.mytimezone ? "block" : "none"}`}>
          {validation.errors.mytimezone}
        </span>

        <div className='text-center my-3'>
          <button type='submit' className='btn btn-primary' disabled={isClicked} style={{ ...(isClicked ? { padding: "2px 18px" } : {}) }}>
            {isClicked ? (
              <div className='d-flex justify-content-center'>
                <Spinner color='white' />
              </div>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </Form>
    </React.Fragment>
  );
};
export default TimeZone;
